<template>
    <b-btn
        size="sm"
        class="btn-block-xs-only"
        variant="success"
        v-bind="$attrs"
        v-on="$listeners"
    >
        <slot>
        <i class="fa fa-plus"></i> Nuevo
        </slot>
    </b-btn>
</template>
<script>
export default {
    inheritAttrs: false
}
</script>
